import { render, staticRenderFns } from "./TextInfo.vue?vue&type=template&id=11905df0&scoped=true&"
import script from "./TextInfo.vue?vue&type=script&lang=js&"
export * from "./TextInfo.vue?vue&type=script&lang=js&"
import style0 from "./TextInfo.vue?vue&type=style&index=0&id=11905df0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11905df0",
  null
  
)

export default component.exports